// Reexport the native module. On web, it will be resolved to ExpoNordicDfuModule.web.ts
// and on native platforms to ExpoNordicDfuModule.ts
export { default } from './ExpoNordicDfuModule'
// export { default as ExpoNordicDfuView } from './ExpoNordicDfuView';
export * from './ExpoNordicDfu.types'
